import Box from '@mui/material/Box'
import { sendDocument } from 'api/documents'
import DialogBase from 'components/dialog/Base'
import { useState } from 'react'

const STATUS = {
  PARTIAL_FAILED: -1,
  FAILED: 0,
  SUCCESS: 1,
}

const text = {
  content: 'ファイルをConcurへ送信しますか？',
  contentMulti: '選択したファイルをConcurへ送信しますか？',
  finished: '送信完了',
  error: '送信エラー',
  confirm: '確認',
  success: 'Concurへ送信されました',
  failed: 'Concurへの送信に失敗しました',
  partialFailed: 'Concurの送信が失敗したファイルがあります',
  partialFailedConfirm: 'エラーファイルを確認してください',
}

const MAX_MSG_WIDTH = 600
const SEE_LOG_MSG = 'エラー原因は利用ログを確認してください'

const dialogContent = (finished: boolean, fromList: boolean, status?: number, message?: string) => {
  if (!finished) {
    return fromList ? text.contentMulti : text.content
  }

  const errList = message?.split('\n') || []
  const errMsg =
    errList.length > 1 ? (
      <ul style={{ textAlign: 'left', maxWidth: MAX_MSG_WIDTH }}>
        {errList?.map((s) => (
          <li key={s}>{s}</li>
        ))}
      </ul>
    ) : (
      errList[0] && <p>{errList[0]}</p>
    )

  if (status === STATUS.SUCCESS) {
    return (
      <>
        <p>{text.finished}</p>
        <Box>{text.success}</Box>
      </>
    )
  }

  if (status === STATUS.PARTIAL_FAILED) {
    return (
      <>
        <p>{text.finished}</p>
        <Box>{text.partialFailed}</Box>
        <p>{SEE_LOG_MSG}</p>
      </>
    )
  }

  return (
    <>
      <p>{text.error}</p>
      <Box>{text.failed}</Box>
      {errMsg}
    </>
  )
}

type Props = {
  open: boolean
  setOpenDialog: (x: boolean) => void
  selectedIDs: string[]
  setSelectedIDs?: (selected: string[]) => void
  fromList: boolean
  reload: () => void
}

const SendDocDialog = ({
  open,
  setOpenDialog,
  selectedIDs,
  setSelectedIDs,
  fromList,
  reload,
}: Props) => {
  const [status, setStatus] = useState<number | undefined>(undefined)
  const [message, setMessage] = useState<string | undefined>(undefined)
  const finished = status !== undefined

  const [loading, setLoading] = useState(false)

  const close = () => {
    setOpenDialog(false)
    setStatus(undefined)
    setMessage(undefined)
    if (reload) reload()
  }

  const submit = async () => {
    setLoading(true)
    try {
      const { errorFlag, results } = (await sendDocument(selectedIDs)).data
      const allSuccess = errorFlag === false

      setStatus(
        allSuccess
          ? STATUS.SUCCESS
          : results.find(({ status }) => status === 0)
            ? STATUS.PARTIAL_FAILED
            : STATUS.FAILED,
      )

      const failedIds = results.filter((x) => x.status !== 0).map((x) => x.objectID)
      if (setSelectedIDs) setSelectedIDs(failedIds)
      setMessage(results[0].message || undefined)
    } catch {
      setStatus(STATUS.FAILED)
      setMessage(undefined)
    }
    setLoading(false)
  }

  const content = dialogContent(finished, fromList, status, message)

  return (
    <DialogBase
      open={open}
      onClose={close}
      onCancel={finished ? undefined : close}
      onAction={finished ? close : submit}
      actionText={finished ? text.confirm : undefined}
      loading={loading}
    >
      {content}
    </DialogBase>
  )
}

export default SendDocDialog
